import { testTimezone } from "@/common/data/timezone";
import { getUtcOffset } from "./getUtcOffset";

export const getTimezoneLabel = (timezoneId: number) => {
  const timezone = testTimezone.find((tz) => tz.id === timezoneId);
  if (!timezone) return "";
  const offset = getUtcOffset(timezone.zone);
  return `${timezone.name} (${timezone.zone}, ${offset})`;
};
